import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import { GlobalStateContext } from "../controller/GlobalState";

function useReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("visible");
          observer.unobserve(e.target);
        }
      }),
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

// A minimal page for "About" mega-menu items that don't have a dedicated
// section elsewhere on the site. `body` is real, already-approved copy
// (drawn from About.jsx / Career.jsx) — not invented claims.
const AboutInfoPage = ({ title, body }) => {
  const navigate = useNavigate();
  const { setIsOpen } = useContext(GlobalStateContext);
  useReveal();

  useEffect(() => {
    document.title = `${title} | InQmise Technologies`;
    const description = document.createElement("meta");
    description.name = "description";
    description.content = `${title} at InQmise Technologies, a software development company in Delhi NCR.`;
    document.head.appendChild(description);

    // This template renders a heading and a sentence or two — a placeholder,
    // not a page (the CSR page body is one sentence). Indexed, it is thin
    // content that drags on site quality. Keep it serving and followable, out
    // of the index until it has something real to say.
    let robots = document.querySelector("meta[name='robots'][data-stub]");
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      robots.setAttribute("data-stub", "true");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");

    return () => {
      description.remove();
      robots.remove();
    };
  }, [title]);

  return (
    <main className="editorial-ai pt-20">
      <section className="ea-wrap ea-section" style={{ textAlign: "center", paddingTop: 64 }}>
        <div className="reveal" style={{ maxWidth: 640, margin: "0 auto" }}>
          <p className="ea-eyebrow" style={{ justifyContent: "center" }}>About InQmise</p>
          <h1 style={{ margin: "13px 0 22px", fontFamily: "Syne, sans-serif", fontSize: "clamp(30px,3.3vw,47px)", lineHeight: 1, letterSpacing: "-.06em", color: "var(--ink)" }}>
            {title}
          </h1>
          {body.map((para, i) => (
            <p key={i} style={{ color: "var(--muted)", fontSize: "var(--t-xs)", lineHeight: 1.8, marginBottom: 16 }}>
              {para}
            </p>
          ))}
          <div className="ea-actions" style={{ justifyContent: "center", marginTop: 24 }}>
            <button onClick={() => setIsOpen(true)} className="ea-button ea-primary">
              Get in touch ↗
            </button>
            <button onClick={() => navigate("/about")} className="ea-text-link">
              Back to About
            </button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AboutInfoPage;
